import {
  iwocapayTelDisplay,
  iwocapayTelLink,
} from '../../../../constants.json';

export const SignupError = () => {
  return (
    <div className="rounded-l border border-secondary-80 bg-structure-100 p-xl text-m font-reg text-primary-10 max-600:rounded-none max-600:p-l">
      <h2 className="text-2xl font-bold text-primary-10 max-600:text-l">
        We need to run a few more checks
      </h2>
      <p>Leave it with us &mdash; you don’t need to do anything.</p>
      <p>
        We’ll be in touch as soon as possible. If this payment is urgent, give
        us a call on{' '}
        <a href={iwocapayTelLink} className="text-m font-reg text-primary-40">
          {iwocapayTelDisplay}
        </a>{' '}
        Mon &ndash; Fri (9am &ndash; 6pm).
      </p>
    </div>
  );
};
